<template>
  <ModalConfirmation
    hasBlur
    :primaryButtonProps="$options.primaryButtonProps"
    :showModal="showModal"
    :title="title"
    @cancel="handleCancel"
    @close="handleClose"
    @save="handleSave"
  >
    <template v-slot:body>
      <HeadingExtraSmall v-if="isWarningEnabled">
        <NotificationInPage
          :notification="notificationConfig"
        />
      </HeadingExtraSmall>
      <ParagraphBody>
        {{ bodyText }}
      </ParagraphBody>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  HeadingExtraSmall,
  ModalConfirmation,
  NotificationInPage,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';

const { PrimaryButtonProps } = Types;
const primaryButtonProps = PrimaryButtonProps({
  text: 'continue',
});
const defaultLabels = {
  bodyText: 'Any changes you have made to this template will be deleted and the content will be reverted to the default. Would you like to continue?',
  title: 'Undo Changes to Settings',
};
const settingsModule = 'SettingsModule';

export default {
  name: 'ModalUndoChanges',

  components: {
    HeadingExtraSmall,
    ModalConfirmation,
    NotificationInPage,
    ParagraphBody,
  },

  props: {
    bodyText: {
      type: String,
      default: defaultLabels.bodyText,
    },
    showModal: Boolean,
    title: {
      type: String,
      default: defaultLabels.title,
    },
  },

  primaryButtonProps,

  computed: {
    ...mapGetters(settingsModule, {
      isCustomer: 'getIsCustomer',
    }),

    isWarningEnabled() {
      return this.$hasFeatureFlag(this.$featureFlags.readOnlyEmailTemplate)
        && !this.isCustomer;
    },

    notificationConfig() {
      return new Types.NotificationConfig({
        icon: 'error',
        isMarkdown: true,
        message: 'Email Customization is now a paid feature. Resetting this template to the default will prevent future customization.',
        showCloseButton: false,
        type: 'warning',
      });
    },
  },

  methods: {
    handleCancel() {
      this.$emit('cancel');
    },

    handleClose() {
      this.$emit('close');
    },

    handleSave() {
      this.$emit('save');
    },
  },
};
</script>
